import {IBlock} from '@core/typings';
import {getAdapterAttributesString, getChildIdx, I18nManager} from '@core/utils';
import {getImg} from '@core/utils/getImg';
import {getPlaceholder} from '@core/utils/getPlaceholder';
import {omit} from 'lodash';
import React from 'react';
import {BlockRenderer} from './BlockRenderer';

export function BasicBlock(props: {
    params: Parameters<IBlock['render']>[0];
    tag: string;
    children?: React.ReactNode;
}) {
    const {
        params,
        params: {data, idx, children: children2, mode},
        tag,
        children,
    } = props;

    const placeholder = data.children.length === 0 && getPlaceholder(params);

    let content = children || children2;
    if (
        (!content || (Array.isArray(content) && content.length === 0)) &&
        data.children.length === 0
    ) {
        content = placeholder;
    }

    if (mode === 'testing' && tag === 'mj-image') {
        let url = data.attributes.src;

        // Imágen dinámica
        if (/{{([\s\S]+?)}}/g.test(url)) {

            const adapterData = omit(params, 'data.attributes.src');

            const { dynamicImage, appendClassNames } = getDynamicImageAndClass(
                I18nManager.localeCode,
                !!adapterData.data.attributes.width
            );

            adapterData.appendClassNames = appendClassNames;

            return (
                <>
                    {`<${tag}
                        ${getAdapterAttributesString(adapterData)}
                        src="${dynamicImage}"
                    >`}

                    {`</${tag}>`}
                </>
            );
        }
        else if (
            url === '' ||
            /\*\|([^\|\*]+)\|\*/g.test(url)
        ) {
            const adapterData = omit(params, 'data.attributes.src');

            return (
                <>
                    {`<${tag} ${getAdapterAttributesString(adapterData)} src="${getImg(
                        'IMAGE_59'
                    )}">`}

                    {`</${tag}>`}
                </>
            );
        }
    }

    return (
        <>
            {`<${tag} ${getAdapterAttributesString(params)}>`}
            {content ||
                data.children.map((child, index) => (
                    <BlockRenderer
                        key={index}
                        {...params}
                        idx={idx ? getChildIdx(idx, index) : null}
                        data={child}
                    />
                ))}
            {`</${tag}>`}
        </>
    );
}

function getDynamicImageAndClass(locale: string, hasWidth: boolean) {
    const imageMap = {
        es: hasWidth ? 'DYNAMIC_IMAGE' : 'DYNAMIC_IMAGE_FULL',
        pt: hasWidth ? 'DYNAMIC_IMAGE_PT' : 'DYNAMIC_IMAGE_PT_FULL',
        it: hasWidth ? 'DYNAMIC_IMAGE_IT' : 'DYNAMIC_IMAGE_IT_FULL',
    };

    const classMap = {
        es: hasWidth ? 'DynamicImage' : 'DynamicImageFull',
        pt: hasWidth ? 'DynamicImage' : 'DynamicImageFull',
        it: hasWidth ? 'DynamicImage' : 'DynamicImageFull',
    };

    return {
        dynamicImage: getImg(imageMap[locale]),
        appendClassNames: classMap[locale],
    };
}
